module.exports = __webpack_public_path__ + "img/2.8bb9989.png";